var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEncouragingSomeoneActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.768 2a2.802 2.802 0 0 0-2.674 1.966l-1.51 4.833c-.11.354-.167.723-.167 1.094V21.25c0 .506.41.917.917.917h8.575c1.842 0 3.46-1.22 3.966-2.992l1.644-5.751a3.208 3.208 0 0 0-3.085-4.09h-4.166a.917.917 0 0 1-.915-.974l.211-3.384A2.801 2.801 0 0 0 11.768 2Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 9.334,
    width: 6.417,
    height: 12.833,
    rx: 0.917,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncouragingSomeoneActive);
export default __webpack_public_path__ + "static/media/encouraging-someone-active.509654fe6621e7f77373b1acf00309e6.svg";
export { ForwardRef as ReactComponent };